var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { CapabilitiesKeyFactory } from '../../query-key-factories';
export const useGetDeveloperPlatformCapabilities = (workspaceId) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const query = useQuery({
        queryFn: () => lucidSdk.workspaceClient(workspaceId).billing().getCapabilities({
            serviceAccounts: true,
            nativeLayout: true,
        }),
        queryKey: CapabilitiesKeyFactory.developerPlatformCapabilities(workspaceId),
        networkMode: 'always',
        retry: false,
    });
    return { query };
};
_react_refresh_temp_1(useGetDeveloperPlatformCapabilities, "H/nX1eMsJ0bsH20/D0j9QAs2SDk=", false, () => [useLucidSdk, useQuery]);
